var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.VectorLayer = new Class({
    Extends: OCS.Viewer.Classes.BaseLayer,
    debug: false,
    class_name: "VectorLayer",
    options: {
        style_type: null
    },
    create: function () {
        var sm = this.get_style_manager();
        var layer_ops = {style: sm.get_layer_style_method()};
        var source = this.get_source();
        if (source) {
            layer_ops.source = source;
        }
        var vector_layer = new ol.layer.Vector(layer_ops);
        this.set_layer(vector_layer);
        return vector_layer;
    },
    refresh_style: function () {
        this.set_style(null);
        this.set_style(this.get_style_manager().get_layer_style_method());
    },
    set_style: function (style) {
        try {
            this.get_ol_object().setStyle(style);
        } catch (e) {

        }
    },

    add_select_feature_mousemove: function () {
        // select interaction working on "mousemove"
        var layers = [this.get_layer()];
        var selectMouseMove = new ol.interaction.Select({
            condition: ol.events.condition.pointerMove,
            addCondition: ol.events.condition.never,
            layers: layers,
            style: this.get_style_manager().get_layer_style_method()
        });
        selectMouseMove.on('select', function (event) {
            event.selected.each(function (feature) {
                feature.set('highlighted', true);
            });
            event.deselected.each(function (feature) {
                feature.set('highlighted', false);
            });
        });

        return selectMouseMove;
    },
    add_select_feature_click: function (in_options) {
        // select interaction working on "click"
        var ops = {
            layers: [this.get_layer()],
            style: this.get_style_manager().get_layer_style_method()
        };

        if (in_options && in_options.selectable_limit > 1) {
            ops.condition = ol.events.condition.click;
            ops.addCondition = ol.events.condition.click;
            ops.removeCondition = ol.events.condition.click;
        } else {
            ops.condition = ol.events.condition.click;
        }

        var selectClick = new ol.interaction.Select(ops);
        selectClick.on('select', function (event) {
            event.selected.each(function (feature) {
                feature.set('selected', true);
            });
            event.deselected.each(function (feature) {
                feature.set('selected', false);
            });
        });

        return selectClick;

    },
    get_style_manager: function () {
        var sm = this.parent();
        // Done this way so that if a style type were to be applied that is seperate from the default, it does not get sabatoged by the default option when a new layer is created
        if (this.options.style_type && sm.get_style_type() === null) {
            sm.set_style_type(this.options.style_type);
        }
        return sm;
    },
});